import React from "react";
import "./WhatIsXpred.css";

type UtilityItem = {
  title: string;
  description: string;
  icon: React.ReactNode;
  fullWidth?: boolean;
};

const utilities: UtilityItem[] = [
  {
    title: "Market Creation",
    description:
      "XPRED holders can propose, design, and launch new prediction markets.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none">
        <path
          d="M12 2L2 7l10 5 10-5-10-5zM2 12l10 5 10-5M2 17l10 5 10-5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Governance Participation",
    description:
      "Holders can vote on platform decisions, upgrades, and community proposals.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none">
        <path
          d="M9 12l2 2 4-4m5-4.5L12 2 4 5.5v6.2c0 5 3.4 9.6 8 10.8 4.6-1.2 8-5.8 8-10.8V5.5z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Market Resolution",
    description:
      "Top 21 holders participate in decentralized outcome resolution via the 5-of-21 multisig.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none">
        <path
          d="M16 11a4 4 0 10-8 0 4 4 0 008 0zM3.5 21a8.5 8.5 0 0117 0M18 8.5a3 3 0 110 5.8M21.5 21a6 6 0 00-4.5-5.8"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Feature Testing & Feedback",
    description:
      "Help test new features, provide inputs, and influence platform development.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none">
        <path
          d="M12 3v1M18.36 5.64l-.7.7M21 12h-1M4 12H3M6.34 6.34l-.7-.7M9 18h6M10 21h4M8.5 15.5a5 5 0 117 0c-.8.8-1.5 1.7-1.5 2.5h-4c0-.8-.7-1.7-1.5-2.5z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Access to Advanced Tools",
    description:
      "Unlock enhanced analytics, dashboards, and ecosystem features.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none">
        <path
          d="M4 19V11M10 19V7M16 19V4M22 19H2M4 11h4v8H4zM10 7h4v12h-4zM16 4h4v15h-4z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Claim Weekly Platform Income",
    description:
      "XPRED holders can log in and claim their proportional share of platform revenue.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none">
        <path
          d="M12 8c-1.7 0-3 .9-3 2s1.3 2 3 2 3 .9 3 2-1.3 2-3 2M12 7v10M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
  {
    title: "Community Growth & Influence",
    description:
      "Holders help shape marketing, platform expansion, and long-term ecosystem direction.",
    fullWidth: true,
    icon: (
      <svg viewBox="0 0 24 24" fill="none">
        <path
          d="M12 2a10 10 0 100 20 10 10 0 000-20zM2 12h20M12 2c2.5 2.7 4 6.1 4 10s-1.5 7.3-4 10M12 2C9.5 4.7 8 8.1 8 12s1.5 7.3 4 10"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
];

const WhatIsXpred: React.FC = () => {
  return (
    <section className="what-is-xpred-container">
      <div className="what-is-xpred-content">
        <h1 className="what-is-xpred-title">What is XPRED?</h1>

        <div className="what-is-xpred-subtitle">
          XPRED Utility - Shaped by the Community
        </div>

        <p className="what-is-xpred-intro">
          XPRED utility will continue to evolve as the community expands the
          platform, but current use cases include:
        </p>

        <div className="utility-grid">
          {utilities.map((item) => (
            <article
              key={item.title}
              className={`utility-card ${item.fullWidth ? "full-width" : ""}`}
            >
              <div className="utility-icon">{item.icon}</div>

              <div className="utility-copy">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="cta-section">
          <div className="cta-divider">
            <span />
            <p>Ready to be part of the future of prediction markets?</p>
            <span />
          </div>

          <a
            href="https://proton.alcor.exchange/trade/xpred-tokencreate_xusdc-xtokens"
            target="_blank"
            rel="noopener noreferrer"
            className="buy-xpred-cta"
          >
            Buy XPRED on Alcor Exchange
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhatIsXpred;
